import React from 'react';

const InvalidFamily: React.FC = () => {
	return (
		<div className="center-center-content">
			<div className="online-booking__error-code-component">
				<div className="text">
					<p>Thank you for trusting us with your pet’s care.</p>
					<p>
						To provide you with the best support during this time, please call us at
						{' '}
						<span className="inline-block">
							<a href="tel:8559335683" className="inline-link">(855) 933-5683</a>
						</span>
						{' '}
						to book your appointment.
					</p>
					<p>We are here to guide you through every step.</p>
				</div>
			</div>
		</div>
	);
};

export default InvalidFamily;
